import { DispatcherCustomerDetailTemplate } from "../../Templates/DispatcherCustomerDetailTemplate";

export const DispatcherCustomerDetail = () => {
  return <DispatcherCustomerDetailTemplate />;
};
